<template>
<div class="activity form dialog-form">
    <el-dialog title="选择活动" :visible.sync="dialogVisible" @close="cancel" width="800px">
        <div class="filters">
            <div class="search">
                <el-input placeholder="输入优惠券名称" v-model="param.name" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add"></div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="selected" ref="multipleTable" max-height="300">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column label="优惠券名称" prop="name"></el-table-column>
            <el-table-column label="情况" prop="datetime">
                <template slot-scope="scope">
                    <div style="text-align: center">{{scope.row.faceprice}}</div>
                    <div>{{scope.row.usescopetypetext}}&nbsp;{{scope.row.facepricetext}}</div>
                </template>
            </el-table-column>
            <el-table-column label="有效期" prop="datetime">
                <template slot-scope="scope">
                    <div>起{{scope.row.expirebegindate}}</div>
                    <div>止{{scope.row.expireenddate}}</div>
                </template>
            </el-table-column>
            <el-table-column label="限制/人" prop="datetime">
                <template slot-scope="scope">
                    <div>{{scope.row.countbyper}}张/人</div>
                    <div>发行量：{{scope.row.totalcount?scope.row.totalcount: '不限制'}}</div>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="submit">确 定</el-button>
</span>
    </el-dialog>
</div>
</template>

<script>
import {getCouponVoucherList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'activity',
    data() {
        return {
            param: {
                name: ''
            },
            page: {
                page: 0,
                pageSize: 10
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: {
                innerid: '',
                name: ''
            },
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {
    },
    updated() {
    },
    methods: {
        handleQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        selected(selection, row) {
            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.innerid) {
                    flag = false
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                this.selectedResult.push({
                    objectid: row.innerid,
                    objectname: row.name,
                    price: row.faceprice,
                    usescopetype: row.usescopetype,
                    requireprice: row.facepricetext,
                    ishave: row.currentgetcount - row.currentusecount
                })
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
            console.log(this.selectedResult)
        },
        openDialog(selectedResult) {
            this.tableData = []
            this.param.subject = ''
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 6,
                pageCount: 0
            }
            this.dialogVisible = false
            this.setLoading(false)
        },
        submit() {
            this.$emit('setCoupon', this.selectedResult)
            this.cancel()
        },
        _getList() {
            this.page.page++
            this.setLoading(true)
            getCouponVoucherList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data)
                    this.page.pageCount = data.pageableData.pageCount
                    if (this.selectedResult.length) {
                        this.tableData.forEach(obj1 => {
                            this.selectedResult.forEach(obj2 => {
                                if (obj1.innerid === obj2.objectid) {
                                    this.$nextTick(() => {
                                        this.$refs.multipleTable.toggleRowSelection(obj1)
                                    })
                                }
                            })
                        })
                    }
                    this.setLoading(false)
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-table__body-wrapper').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.page.page < _this.page.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getList()
                                }
                            }
                        })
                    })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        usescopetype: function (value) {
            switch (value) {
            case 1: value = '全部商品'
                break
            case 2: value = '指定商品'
                break
            }
            return value
        }
    },
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.activity {
    .el-dialog{
        width: 650px;
    }
    .el-dialog .el-button{
        margin-bottom: 0;
        margin-left: 30px;
    }
    .el-date-editor .el-range-separator,.filters .el-input__icon{
        line-height: 26px;
    }
    .el-table th>.cell:nth-child(1)>label{
        display: none;
    }
    .filters{
        @include flexBox(flex-start);
        .search{
            .el-input{
                width: 240px !important;
            }
        }
    }
    .imageText{
        @include flexBox(flex-start);
        img{
            min-width: 74px;
            max-width: 74px;
            height: 42px;
            margin-right: 10px;
        }
    }
}
</style>
